

export interface AddQueueSinkOperationResult {
    raftCommandIndex: number;
    taskId: number;
}